"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireDefault(require("react"));
var _propTypes = require("prop-types");
var _ReadinessCheck = require("./ReadinessCheck.styled");
var _passedReadiness = _interopRequireDefault(require("./passed-readiness.svg"));
var _failedReadiness = _interopRequireDefault(require("./failed-readiness.svg"));
var _permissionDeniedReadiness = _interopRequireDefault(require("./permission-denied-readiness.svg"));
var _reactstrap = require("reactstrap");
var _constants = require("../../constants");
var _Reusable = require("../../constants/Reusable");
var _statusTextMap;
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != (0, _typeof2["default"])(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var SampleAudio = _react["default"].lazy(function () {
  return process.env.STORYBOOK_CI ? Promise.resolve().then(function () {
    return _interopRequireWildcard(require("./EmptyAudio"));
  }) : Promise.resolve().then(function () {
    return _interopRequireWildcard(require("./SampleAudio"));
  });
});
var speakerTitle = 'Speaker';
var screenShareTitle = 'Screen share';
var isPermissionDeniedOrFailed = function isPermissionDeniedOrFailed(title) {
  var allowedTitles = ['Microphone', 'Camera'];
  return allowedTitles.includes(title);
};
var ReadinessCheck = function ReadinessCheck(_ref) {
  var title = _ref.title,
    status = _ref.status,
    statusText = _ref.statusText,
    onRetry = _ref.onRetry,
    children = _ref.children,
    onConfirm = _ref.onConfirm,
    failedText = _ref.failedText,
    hideBottomBorder = _ref.hideBottomBorder,
    showSpeakerTest = _ref.showSpeakerTest,
    onSetShowSpeakerTest = _ref.onSetShowSpeakerTest,
    presenterId = _ref.presenterId;
  var hasFailed = [_constants.FAILED, _constants.PERMISSION_DENIED].includes(status);
  var onConfirmCallback = (0, _Reusable.useEnterUpCallback)(onConfirm);
  var onCancelCallback = (0, _Reusable.useEnterDownCallback)(onConfirm);
  return _react["default"].createElement(_ReadinessCheck.ReadinessWrapper, {
    hideBottomBorder: hideBottomBorder || false
  }, _react["default"].createElement(_ReadinessCheck.StyledDeviceTitle, null, title), _react["default"].createElement(_ReadinessCheck.ContentArea, null, _react["default"].createElement(_ReadinessCheck.IconTextWrapper, null, status !== _constants.CHECKING && status !== _constants.WAITING && _react["default"].createElement(_ReadinessCheck.StyledIcon, {
    src: iconsMap[status]
  }), status === _constants.CHECKING && title !== speakerTitle && _react["default"].createElement(_ReadinessCheck.StyledSpinner, null, _react["default"].createElement(_reactstrap.Spinner, {
    size: 'sm'
  }), ' '), status === _constants.WAITING ? _react["default"].createElement(_ReadinessCheck.TextWrapper, null, _react["default"].createElement(_ReadinessCheck.FlexDiv, null, _react["default"].createElement(_ReadinessCheck.StyledSpinner, null, _react["default"].createElement(_reactstrap.Spinner, {
    size: 'sm'
  }), ' '), _react["default"].createElement(_ReadinessCheck.StyledText, {
    status: status
  }, _react["default"].createElement("div", {
    "data-testid": "".concat(title, "-").concat(status)
  }, "Waiting... "))), ' ', _react["default"].createElement(_ReadinessCheck.StyledP, null, _react["default"].createElement(_ReadinessCheck.StyledLink, {
    className: "dd-privacy-mask",
    "data-testid": "screenShare-yes",
    onClick: function onClick() {
      return onConfirm(true);
    },
    role: "button",
    "data-dd-action-name": "Screen Share Readiness Check - Start - (".concat(presenterId, ")"),
    onKeyDown: onConfirmCallback,
    tabIndex: "0"
  }, "Start test"), ' ', _react["default"].createElement(_ReadinessCheck.StyledLink, {
    className: "dd-privacy-mask",
    "data-testid": "screenShare-no",
    onClick: function onClick() {
      return onConfirm(false);
    },
    role: "button",
    "data-dd-action-name": "Screen Share Readiness Check - Skip - (".concat(presenterId, ")"),
    onKeyDown: onCancelCallback,
    tabIndex: "0"
  }, "Skip")), _react["default"].createElement(_ReadinessCheck.StyledI, null, "No content will actually be shared during the test")) : _react["default"].createElement(_ReadinessCheck.StyledText, {
    status: status
  }, status === _constants.CHECKING && title === speakerTitle ? null : _react["default"].createElement("div", {
    "data-testid": "".concat(title, "-").concat(status)
  }, hasFailed ? failedText : statusText || statusTextMap[status]))), status !== _constants.WAITING && _react["default"].createElement(_ReadinessCheck.StyledText, {
    status: status
  }, [_constants.SKIPPED, _constants.PERMISSION_DENIED, _constants.FAILED].includes(status) ? children : null), showSpeakerTest && status === _constants.CHECKING && title === speakerTitle && _react["default"].createElement(_react["default"].Fragment, null, _react["default"].createElement(_ReadinessCheck.StyledAudioWrapper, null, _react["default"].createElement(_reactstrap.Spinner, {
    size: 'sm'
  }), ' ', _react["default"].createElement("span", {
    "data-testid": "audio-readiness-check"
  }, "Playing test sound...")), _react["default"].createElement(_ReadinessCheck.StyledP, null, "Is the speaker working?", ' ', _react["default"].createElement(_ReadinessCheck.StyledLink, {
    className: "dd-privacy-mask",
    "data-testid": "speakerWorking-yes",
    onClick: function onClick() {
      return onConfirm(true);
    },
    role: "button",
    "data-dd-action-name": "Speaker Readiness Check - Yes - (".concat(presenterId, ")"),
    onKeyDown: onConfirmCallback,
    tabIndex: "0"
  }, "Yes"), ' ', _react["default"].createElement(_ReadinessCheck.StyledLink, {
    className: "dd-privacy-mask",
    "data-testid": "speakerWorking-no",
    onClick: function onClick() {
      return onConfirm(false);
    },
    role: "button",
    "data-dd-action-name": "Speaker Readiness Check - No - (".concat(presenterId, ")"),
    onKeyDown: onCancelCallback,
    tabIndex: "0"
  }, "No"), _react["default"].createElement(SampleAudio, null))), !showSpeakerTest && title === speakerTitle && _react["default"].createElement(_react["default"].Fragment, null, _react["default"].createElement(_ReadinessCheck.TextWrapper, null, _react["default"].createElement(_ReadinessCheck.StyledP, null, _react["default"].createElement(_ReadinessCheck.StyledLink, {
    className: "dd-privacy-mask",
    "data-testid": "showSpeakerTest-yes",
    onClick: function onClick() {
      return onSetShowSpeakerTest(true);
    },
    role: "button",
    "data-dd-action-name": "Start Speaker Readiness Check - (".concat(presenterId, ")"),
    onKeyDown: function onKeyDown(e) {
      return (0, _Reusable.handleEnterDown)(e, function () {
        return onSetShowSpeakerTest(true);
      });
    },
    tabIndex: "0"
  }, "Start test"), ' '), _react["default"].createElement(_ReadinessCheck.StyledI, null, "Click to play speaker test"))), hasFailed && title !== screenShareTitle && _react["default"].createElement(_ReadinessCheck.FooterButtonWrapper, null, isPermissionDeniedOrFailed(title) ? _react["default"].createElement(_ReadinessCheck.StyledLink, {
    "data-testid": "learn-more",
    href: "https://support.cvent.com/s/communityarticle/Configuring-Desktop-and-Browser-Settings-for-Studio-Directors-and-Presenters?searchFor=studio%20browser&lang=en_US",
    rel: "noreferrer noopener",
    target: "_blank"
  }, "Learn more") : _react["default"].createElement(_react["default"].Fragment, null, onRetry ? _react["default"].createElement(_ReadinessCheck.StyledLink, {
    "data-testid": "try-again",
    onClick: onRetry,
    onKeyDown: function onKeyDown(e) {
      return (0, _Reusable.handleEnterDown)(e, onRetry);
    },
    tabIndex: "0"
  }, "Try again") : null))));
};
var iconsMap = (0, _defineProperty2["default"])({
  passed: _passedReadiness["default"],
  failed: _failedReadiness["default"],
  permission_denied: _permissionDeniedReadiness["default"]
}, _constants.SKIPPED, _permissionDeniedReadiness["default"]);
var statusTextMap = (_statusTextMap = {}, (0, _defineProperty2["default"])(_statusTextMap, _constants.PASSED, 'Ready!'), (0, _defineProperty2["default"])(_statusTextMap, _constants.FAILED, 'Not connected or permission not granted'), (0, _defineProperty2["default"])(_statusTextMap, _constants.CHECKING, 'Checking...'), _statusTextMap);
ReadinessCheck.defaultProps = {
  learnMoreLink: '//#'
};
ReadinessCheck.propTypes = {
  title: _propTypes.string.isRequired,
  status: _propTypes.string.isRequired,
  statusText: _propTypes.string,
  children: _propTypes.element,
  onConfirm: _propTypes.func,
  showSpeakerTest: _propTypes.bool,
  onSetShowSpeakerTest: _propTypes.func
};
var _default = exports["default"] = ReadinessCheck;